import WebServices from '../WebServices';
import {
    PROCEDURES_MANUAL_FETCH, PROCEDURES_MANUAL_FETCH_ERROR, PROCEDURES_MANUAL_FETCH_SUCCESS, PROCEDURES_MANUAL_HIDE, PROCEDURES_MANUAL_SHOW,
    PROCEDURES_MANUAL_UPDATE_HEADER, PROCEDURES_MANUAL_UPDATE_HEADER_ERROR, PROCEDURES_MANUAL_UPDATE_HEADER_SUCESS, PROCEDURES_MANUAL_CREATE, PROCEDURES_MANUAL_CREATE_SUCCESS, PROCEDURES_MANUAL_CREATE_ERROR, PROCEDURES_MANUAL_UPDATE
} from './Types';
import { showSnackBarMessage } from './AppInfoActions';

const showProcedureManual = ({ functionId, projectId, canCurrentUserUpdateProcedureManual, readOnly }) => (dispatch) => {

    dispatch({ type: PROCEDURES_MANUAL_SHOW, payload: { functionId, projectId, canCurrentUserUpdateProcedureManual, readOnly } });
    dispatch(getProcedureManual({ functionId, projectId }));


}


const getProcedureManual = ({ functionId, projectId }) => (dispatch) => {

    let webServices = new WebServices();
    dispatch({ type: PROCEDURES_MANUAL_FETCH, payload: { functionId, projectId } });

    webServices.getProcedureManual({ functionId, projectId })
        .then((actions) => {

            dispatch({ type: PROCEDURES_MANUAL_FETCH_SUCCESS, payload: actions });

        })
        .catch((error) => {
            dispatch({ type: PROCEDURES_MANUAL_FETCH_ERROR, payload: error });
        });

}

const createProcedureManual = ({ projectId, functionId, sdn, rev, comment = '' }) => async dispatch => {

    let webServices = new WebServices();
    dispatch({ type: PROCEDURES_MANUAL_CREATE, payload: { projectId, functionId } });

    try {
        await webServices.updateProcedureManualHeader({ projectId, functionId, sdn, rev, comment })
        await webServices.createProcedureManual({ projectId, functionId })
        const procedureManual = await webServices.getProcedureManual({ functionId, projectId });
        dispatch({ type: PROCEDURES_MANUAL_CREATE_SUCCESS, payload: procedureManual });
        dispatch(showSnackBarMessage("Procedure Manual Created"))

    } catch (error) {
        dispatch(showSnackBarMessage("Error Creating Procedure Manual"))
        dispatch({ type: PROCEDURES_MANUAL_CREATE_ERROR, payload: error });
    }

}



const updateSDN = ({ projectId, functionId, sdn, rev, comment = '' }) => dispatch => {

    let webServices = new WebServices();
    dispatch({ type: PROCEDURES_MANUAL_UPDATE_HEADER, payload: { projectId, functionId, sdn } });

    webServices.updateProcedureManualHeader({ projectId, functionId, sdn, rev, comment })
        .then((header) => {
            dispatch(showSnackBarMessage("SDN Number Updated"))
            dispatch({ type: PROCEDURES_MANUAL_UPDATE_HEADER_SUCESS, payload: header });

        })
        .catch((error) => {
            dispatch(showSnackBarMessage("Error Updating SDN Number"))
            dispatch({ type: PROCEDURES_MANUAL_UPDATE_HEADER_ERROR, payload: error });
        });
}

const hideProcedureManual = () => ({ type: PROCEDURES_MANUAL_HIDE })



export { showProcedureManual, getProcedureManual, hideProcedureManual, updateSDN, createProcedureManual };

